<template>
  <div class="case-page-container">
    <div class="banner-container">
      <div class="title case-page-show">
        <span>案例展示</span>
        <span>Case</span>
        <span
        >持续创新改变，持续创造用户价值，持续推动客户增长把需求转化为优雅的设计</span
        >
      </div>
    </div>
    <div class="case-exhibit-container">
      <div class="title case-page-show">
        <span>产品是商业价值的核心容器</span>
      </div>
      <div class="select-cell">
        <div class="select-cell-value" v-for="item in selectList"
             :class="{activeCell:selectId==item.id}"
             @click="selectCell(item)">
          {{item.title}}
        </div>
      </div>
      <div class="case-card-container">
        <div
          class="case-card case-page-img-show"
          v-for="item in caseData"
          :key="item.id"
          @click="toCaseDetail(item.id)"
        >
          <img :src="item.imgUrl" alt=""/>
          <div class="card-content-cell">
            <div class="card-cell-name">
              {{item.name}}
            </div>
            <div class="card-cell-title">
              {{item.title}}
            </div>
            <div class="span-cell">
              <div class="cell-value" v-for="itemValue in item.span">{{itemValue}}</div>
            </div>
          </div>
        </div>
        <div class="case-card case-page-img-show">
          <img src="@/assets/image/more-case.png" style="height: 453px" alt=""/>
        </div>
        <i v-for="item in 10" :key="'i' + item"></i>
      </div>
    </div>
    <contact-us></contact-us>
  </div>
</template>

<script>
  import contactUs from "@/components/contactUs";
  import scrollReveal from "scrollreveal";

  export default {
    components: {
      contactUs,
    },
    data() {
      return {
        scrollReveal: scrollReveal(),
        selectId: 1,
        selectList: [
          {
            id: 1,
            title: '全部案例'
          },
          {
            id: 2,
            title: '互联网+'
          },
          {
            id: 3,
            title: '智慧医疗'
          },
          {
            id: 4,
            title: '客户管理'
          },
          {
            id: 5,
            title: '金融服务'
          },
          {
            id: 6,
            title: 'SaaS系统'
          },
          {
            id: 7,
            title: '物联网'
          },
          {
            id: 8,
            title: '智慧教育'
          },
          {
            id: 9,
            title: '智慧工具'
          },
          {
            id: 10,
            title: '政务服务'
          },
          {
            id: 11,
            title: '社交应用'
          },
        ],
        caseData: [
          {
            id: 1,
            name: "督促系统",
            title: '执前督促溯源治理系统',
            span: ['互联网+督促', '后台系统', '小程序'],
            imgUrl: require("@/assets/image/dcxt.png"),
          },
          {
            id: 2,
            name: "速证云",
            title: '赋予强制执行视频面签工具',
            span: ['智慧政务', '小程序'],
            imgUrl: require("@/assets/image/szy.png"),
          },
          {
            id: 3,
            name: "玛莉亚U+",
            title: '医疗综合服务营销平台',
            span: ['智慧医疗', '小程序'],
            imgUrl: require("@/assets/image/mlyu+.png"),
          },
          {
            id: 4,
            name: "KAPIPO",
            title: '线上少儿教育平台',
            span: ['线上教育', '小程序'],
            imgUrl: require("@/assets/image/kapipo.png"),
          },
          {
            id: 5,
            name: "乐谷农业",
            title: '线上线下票务系统',
            span: ['互联网+教育', '小程序'],
            imgUrl: require("@/assets/image/lgny.png"),
          },
          {
            id: 6,
            name: "众诺CRM",
            title: '医疗客户管理SaaS系统',
            span: ['客户管理', '中后台'],
            imgUrl: require("@/assets/image/zncrm.png"),
          },
          {
            id: 7,
            name: "PDF合并",
            title: 'PDF合并/管理工具',
            span: ['智慧工具', '平台'],
            imgUrl: require("@/assets/image/pdf.png"),
          },
          {
            id: 8,
            name: "审批签章",
            title: '杭州国土局签章审批平台',
            span: ['智慧工具', '小程序', '后台'],
            imgUrl: require("@/assets/image/qzsp.png"),
          },
          {
            id: 9,
            name: "在线投票",
            title: '杭州国土局在线投票平台',
            span: ['政务服务', '小程序', '后台'],
            imgUrl: require("@/assets/image/zxtp.png"),
          },
          {
            id: 10,
            name: "识别系统",
            title: '人像信息识别系统',
            span: ['政务服务', '后台'],
            imgUrl: require("@/assets/image/sbxt.png"),
          },
          {
            id: 11,
            name: "OA系统",
            title: '智能 OA 系统',
            span: ['智慧工具', '后台'],
            imgUrl: require("@/assets/image/sjoa.png"),
          },
          {
            id: 12,
            name: "社交应用",
            title: '附近真人在线社交应用',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/sjyy.png"),
          },
          {
            id: 13,
            name: "超声影像系统",
            title: '妇产医院超声影像系统',
            span: ['智慧医疗', '系统'],
            imgUrl: require("@/assets/image/csyxst.png"),
          },
          {
            id: 14,
            name: "慈善捐助",
            title: '杭州西湖慈善总会捐助平台',
            span: ['智慧工具', '平台'],
            imgUrl: require("@/assets/image/csjz.png"),
          },
          {
            id: 15,
            name: "深时数字地球",
            title: '深时数字地球平台',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/ssszdq.png"),
          },
          {
            id: 16,
            name: "古生物矿物学",
            title: '古生物+矿物学查询系统',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/gswkwx.png"),
          },
          {
            id: 17,
            name: "矿物蚀变",
            title: '矿物蚀变提取平台',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/kwsb.png"),
          },
          {
            id: 18,
            name: "DDE竞赛",
            title: 'DDE全国大学生地质竞赛',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/dde.png"),
          },
          {
            id: 19,
            name: "伏羲",
            title: '全球综合观测大数据知识化管理与服务平台',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/fuxi.png"),
          },
          {
            id: 20,
            name: "物产中大",
            title: '物产中大项目资源库',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/wczd.png"),
          },
          {
            id: 21,
            name: "至信云调",
            title: '线上多元纠纷调解系统（PC端）',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/zxyt.png"),
          },
          {
            id: 22,
            name: "IDDIS",
            title: '国际灾害数据和信息服务',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/iddis.png"),
          },
          {
            id: 23,
            name: "猩猩牌谱",
            title: '德州扑克牌谱生成工具',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/xxpp.png"),
          },
          {
            id: 24,
            name: "企业微信",
            title: '医疗CRM+企业微信生态',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/qywx.png"),
          },
          {
            id: 25,
            name: "DDEMR",
            title: '深时数字地球与矿产资源',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/ddemr.png"),
          },
          {
            id: 26,
            name: "多元纠纷化解",
            title: '线上多元纠纷调解系统（小程序）',
            span: ['社交应用', 'APP'],
            imgUrl: require("@/assets/image/dyjfhj.png"),
          },
          // {
          //   id: 12,
          //   name: "more",
          //   imgUrl: require("@/assets/image/more-case.png"),
          // },
        ],
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.scrollReveal.reveal(".case-page-show", {
          duration: 250,
          delay: 0,
          interval: 100,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "100px",
          opacity: 0.0,
          easing: "linear",
          scale: 0.9,
        });
        this.scrollReveal.reveal(".case-page-img-show", {
          duration: 200,
          delay: 0,
          interval: 50,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "0",
          opacity: 0.0,
          easing: "linear",
          scale: 0.7,
        });
      });
    },
    methods: {
      selectCell(item) {
        this.selectId = item.id
      },
      toCaseDetail(id) {
        this.$router.push({
          path: "/case",
          query: {
            id: id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .case-page-container {
    background: #F3F5FB;

    .banner-container {
      background: url("../../../assets/image/main-background.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      height: 726px;
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #ffffff;
          text-align: center;
        }

        span + span {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #0057ff;
          text-align: center;
        }

        span + span + span {
          margin-top: 40px;
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #ffffff;
        }
      }
    }

    .case-exhibit-container {
      .title {
        margin: 100px 0 80px 0;
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #000000;
        text-align: center;
      }

      .select-cell {
        max-width: 1200px;
        margin: 40px auto;
        display: flex;
        align-items: center;

        .select-cell-value {
          cursor: pointer;
          margin-left: 10px;
          padding: 4px 20px;
          color: #000000;
          font-size: 14px;
          border-radius: 20px;
          background: #FFFFFF;
        }

        .activeCell {
          background: #0057FF;
          color: #ffffff;
        }
      }

      .case-card-container {
        width: 1200px;
        margin: 0 auto 85px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        .case-card {
          margin-bottom: 15px;
          cursor: pointer;
          user-select: none;
          display: flex;
          flex-direction: column;

          &:hover {
            transform: translateY(-5px) !important;
            // transform: translate3d(5px, -5px, 0) !important;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.3);
            transition: all 0.3s;
          }

          .card-content-cell {
            background: #ffffff;
            padding: 20px;

            .card-cell-name {
              color: #000000;
              font-size: 24px;
              font-weight: bold;
            }

            .card-cell-title {
              margin-top: 8px;
              color: #000000;
              font-size: 16px;
              font-weight: normal;
            }

            .span-cell {
              margin-top: 20px;
              display: flex;
              align-items: center;

              .cell-value:first-child {
                margin-left: 0;
              }

              .cell-value {
                margin-left: 6px;
                padding: 2px 14px;
                background: #EFEEF2;
                color: #5E5E5E;
                font-size: 14px;
                border-radius: 20px;
              }
            }
          }


          img {
            display: block;
            width: 387px;
            height: 300px;

          }
        }

        i {
          width: 390px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/details/components/casePage.vue